var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.puedeEditar ||
                      _vm.puedeEliminar ||
                      _vm.puedeConsultar,
                    expression: "puedeEditar || puedeEliminar || puedeConsultar"
                  }
                ],
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.puedeCrear,
                    expression: "puedeCrear"
                  }
                ],
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.agregar }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _c("span", [_vm._v("Nuevo")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", { attrs: { for: "hoy" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "tipo_fecha",
                      id: "hoy",
                      value: "H"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "ayer" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "tipo_fecha",
                      id: "ayer",
                      value: "A"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "personalizado" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: {
                      value: "P",
                      type: "radio",
                      name: "tipo_fecha",
                      id: "personalizado"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                    on: {
                      change: [
                        function($event) {
                          return _vm.$set(_vm.form, "tipo_fecha", "P")
                        },
                        _vm.changePersonalizado
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipo_fecha === "P",
                        expression: "form.tipo_fecha === 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("date-picker", {
                          attrs: { type: "date", id: "desde" },
                          on: { enterkey: _vm.consultar },
                          model: {
                            value: _vm.form.desde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "desde", $$v)
                            },
                            expression: "form.desde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v(_vm._s(_vm.$t("message.desde")))]),
                        _vm._v(" "),
                        _vm.errores.desde
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.desde[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipo_fecha === "P",
                        expression: "form.tipo_fecha === 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("date-picker", {
                          attrs: { type: "hasta", id: "hasta" },
                          on: { enterkey: _vm.consultar },
                          model: {
                            value: _vm.form.hasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hasta", $$v)
                            },
                            expression: "form.hasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v(_vm._s(_vm.$t("message.hasta")))]),
                        _vm._v(" "),
                        _vm.errores.hasta
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.hasta[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.lineas.length > 1,
                        expression: "lineas.length > 1"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              options: _vm.lineas,
                              label: "name",
                              id: "linea",
                              placeholder: "Seleccione..."
                            },
                            on: { input: _vm.inputLinea },
                            model: {
                              value: _vm.selectedLinea,
                              callback: function($$v) {
                                _vm.selectedLinea = $$v
                              },
                              expression: "selectedLinea"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "linea" } }, [
                            _vm._v("Línea")
                          ])
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c(
              "tabs",
              {
                attrs: { options: { defaultTabHash: "procesados" } },
                on: { changed: _vm.tabChanged }
              },
              [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: { id: "search", placeholder: "Consultar..." },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.consultar.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.form.buscar,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "buscar", $$v)
                        },
                        expression: "form.buscar"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("tab", { attrs: { id: "procesados", name: "Procesados" } }, [
                  _c(
                    "div",
                    { staticClass: "table-responsive" },
                    [
                      _c("k-table", {
                        ref: "consultaEcas",
                        attrs: {
                          buttons: [
                            {
                              class: "btn-info",
                              icon: "fa-edit",
                              event: "editar"
                            },
                            {
                              class: "btn-secondary",
                              icon: "fa-file",
                              event: "verLogs"
                            },
                            {
                              class: "btn-danger",
                              icon: "fa-trash",
                              event: "eliminar"
                            }
                          ],
                          noForms: "",
                          params: _vm.form,
                          mostrarTodos: false,
                          columns: [
                            {
                              display: "Fecha de emisión",
                              value: "fecha_emision"
                            },
                            {
                              display: "Nº Oficio",
                              value: "oficio_no"
                            },
                            {
                              display: "Marca",
                              value: "marca"
                            },
                            {
                              display: "Nave",
                              value: "nave"
                            },
                            {
                              display: "Viaje",
                              value: "viaje"
                            },
                            {
                              display: "Embarque",
                              value: "embarque"
                            },
                            {
                              display: "Línea",
                              value: "linea"
                            },
                            {
                              display: "A. Nave",
                              value: "arriba_nave"
                            },
                            {
                              display: "Importador",
                              value: "importador"
                            },
                            {
                              display: "Contenedor",
                              value: "contenedor"
                            },
                            {
                              display: "Tipo de contenedor",
                              value: "tipo_contenedor"
                            },
                            {
                              display: "Fecha de inicio",
                              value: "fecha_inicio"
                            },
                            {
                              display: "Fecha de caducidad",
                              value: "fecha_caducidad"
                            },
                            {
                              display: "Procesamiento",
                              value: "fecha_procesamiento"
                            },
                            {
                              display: "Fichero",
                              value: "kim_path"
                            }
                          ],
                          path: _vm.path,
                          deleteButton: false,
                          createButton: false,
                          editButton: false
                        },
                        on: {
                          verLogs: _vm.verLogs,
                          editar: _vm.editar,
                          eliminar: _vm.eliminar
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tab",
                  { attrs: { id: "no-procesados", name: "No procesados" } },
                  [
                    _c(
                      "div",
                      { staticClass: "table-responsive" },
                      [
                        _c("k-table", {
                          ref: "consultaProcesados",
                          attrs: {
                            buttons: [
                              {
                                class: "btn-info btn--text",
                                icon: "fa-eye",
                                event: "verNoProcesado"
                              }
                            ],
                            noForms: "",
                            params: _vm.form,
                            mostrarTodos: false,
                            columns: [
                              {
                                display: "Fichero",
                                value: "path"
                              },
                              {
                                display: "Fecha",
                                value: "created_at"
                              }
                            ],
                            path: _vm.path,
                            deleteButton: false,
                            createButton: false,
                            editButton: false
                          },
                          on: { verNoProcesado: _vm.verNoProcesado }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "ecas",
            scrollable: "",
            height: "auto",
            width: "85%"
          }
        },
        [
          _c("ecas", {
            attrs: {
              yards: _vm.yards,
              tipoFormulario: _vm.tipoFormulario,
              lineas: _vm.lineas,
              tiposContenedor: _vm.tiposContenedor,
              naves: _vm.naves,
              telefonos: _vm.telefonos
            },
            on: { saved: _vm.saved, cancelar: _vm.cancelarEcas },
            model: {
              value: _vm.currentEcas,
              callback: function($$v) {
                _vm.currentEcas = $$v
              },
              expression: "currentEcas"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "logs",
            scrollable: "",
            height: "auto",
            width: "65%"
          }
        },
        [
          _c("log-no-procesados", {
            attrs: { path: _vm.currentPath },
            on: {
              procesado: _vm.procesado,
              cerrar: function($event) {
                return _vm.$modal.hide("logs")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "logsEcasCoparn",
            scrollable: "",
            height: "auto",
            width: "65%"
          }
        },
        [
          _c("logs-ecas-coparn", {
            attrs: { id: _vm.currentId },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("logsEcasCoparn")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Consulta ECAS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-087a97b5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-087a97b5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ecas-coparn/ConsultaEcas.vue
// module id = 418
// module chunks = 0